import React from 'react'
import { Typography, useTheme, Stack } from '@mui/material'
import { Trans } from 'react-i18next'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  accordion: {
    backgroundColor: theme.palette.shades.shade04,
  },
  content: {
    padding: theme.spacing(2, 4, 2, 4),
  },
}))

/**
 * Accordion component to show consequence of accepting, rejecting and ignoring request.
 */
const OwnerAccessRequestAccordion: React.FC = Props => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const { classes } = useStyles()

  return (
    <AccordionItem title={t('dashboard.access-request-dialog.accordion.title')} className={classes.accordion} contentClassName={classes.content}>
      <Stack gap={2}>
        <Typography variant="body2">
          <Trans
            i18nKey="dashboard.access-request-dialog.accordion.consequence-accept"
            components={{ bold: <Typography variant="subtitle1" color={theme.palette.primary.main} component="span" /> }}
          />
        </Typography>

        <Typography variant="body2">
          <Trans
            i18nKey="dashboard.access-request-dialog.accordion.consequence-reject"
            components={{ bold: <Typography variant="subtitle1" color={theme.palette.warning.main} component="span" /> }}
          />
        </Typography>

        <Typography variant="body2">
          <Trans
            i18nKey="dashboard.access-request-dialog.accordion.consequence-ignore"
            components={{ bold: <Typography variant="subtitle1" color={theme.palette.text.primary} component="span" /> }}
          />
        </Typography>
      </Stack>
    </AccordionItem>
  )
}

export default OwnerAccessRequestAccordion
